export default "__VITE_ASSET__BI4jtync__"